/*
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2024-09-06 15:16:23
 * @Description: 路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//以下代码解决路由地址重复的报错问题
// const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

const routes = [
    //首页
  {
    path: '/',
    redirect: {
		name: 'Home',
	}
  },
  {
    path: '/home',
    name: 'Home',
    meta:{pathSet:"/home"},
    component: () => import("@/views/home/NewHome.vue")
  },
  //注册
  {
    path: '/register',
    name: 'Register',
    component: () => import("@/views/login/Register.vue")
  },
  //登录
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: () => import("@/views/login/ForgetPassword.vue")
  },
  //api文档
  {
    path: '/apiDoc',
    name: 'ApiDoc',
    redirect:{name:'apiDocIndex'},
    component: () => import("@/views/apiDoc/Index.vue"),
    children:[{
      path:"/apiDoc/index",
      name:"apiDocIndex",
      meta:{pathSet:"/apiDoc",title:"极兔API简介"},
      component:() => import("@/views/apiDoc/apiDocIndex.vue"),
    },{
      path:"/apiDoc/basic",
      name:"basic",
      meta:{pathSet:"/apiDoc",title:"获取极兔省市区"},
      component:() => import("@/views/apiDoc/children/basic/index.vue"),
    },{
      path:"/apiDoc/orderserve/create",
      name:"createOrder",
      meta:{pathSet:"/apiDoc",title:"创建订单"},
      component:() => import("@/views/apiDoc/children/orderserve/create.vue"),
    },{
      path:"/apiDoc/orderserve/createWithWaybillNo",
      name:"createWithWaybillNoOrder",
      meta:{pathSet:"/apiDoc",title:"创建订单（带运单号）"},
      component:() => import("@/views/apiDoc/children/orderserve/createWithWaybillNo.vue"),
    },{
      path:"/apiDoc/orderserve/query",
      name:"queryOrder",
      meta:{pathSet:"/apiDoc",title:"查询订单"},
      component:() => import("@/views/apiDoc/children/orderserve/query.vue"),
    },{
      path:"/apiDoc/orderserve/cancel",
      name:"cancelOrder",
      meta:{pathSet:"/apiDoc",title:"取消订单"},
      component:() => import("@/views/apiDoc/children/orderserve/cancel.vue"),
    },
    {
      path:"/apiDoc/orderserve/statusFeedback",
      name:"orderStatusFeedback",
      meta:{pathSet:"/apiDoc",title:"订单状态回传"},
      component:() => import("@/views/apiDoc/children/orderserve/statusFeedback.vue"),
    },
    {
      path:"/apiDoc/orderserve/addLooseOrder",
      name:"addLooseOrder",
      meta:{pathSet:"/apiDoc",title:"订单状态回传"},
      component:() => import("@/views/apiDoc/children/orderserve/addLooseOrder.vue"),
    },
    {
      path:"/apiDoc/vip/query",
      name:"vipQuery",
      meta:{pathSet:"/apiDoc",title:"电子面单账号检验"},
      component:() => import("@/views/apiDoc/children/vip/query.vue"),
    },
    {
      path:"/apiDoc/vip/balance",
      name:"vipBalance",
      meta:{pathSet:"/apiDoc",title:"电子面单余额查询"},
      component:() => import("@/views/apiDoc/children/vip/balance.vue"),
    },
    {
      path:"/apiDoc/vip/getwaybill",
      name:"vipGetwaybill",
      meta:{pathSet:"/apiDoc",title:"获取电子面单"},
      component:() => import("@/views/apiDoc/children/vip/getwaybill.vue"),
    },
    {
      path:"/apiDoc/vip/printOrder",
      name:"printOrder",
      meta:{pathSet:"/apiDoc",title:"面单打印"},
      component:() => import("@/views/apiDoc/children/vip/printOrder.vue"),
    },{
      path:"/apiDoc/logistics/query",
      name:"logisticsQuery",
      meta:{pathSet:"/apiDoc",title:"物流轨迹查询"},
      component:() => import("@/views/apiDoc/children/logistics/query.vue"),
    },
    {
      path:"/apiDoc/logistics/statusFeedback",
      name:"logisticsStatusFeedback",
      meta:{pathSet:"/apiDoc",title:"物流轨迹回传"},
      component:() => import("@/views/apiDoc/children/logistics/statusFeedback.vue"),
    },{
      path:"/apiDoc/logistics/subscribe",
      name:"logisticsSubscribe",
      meta:{pathSet:"/apiDoc",title:"物流轨迹订阅"},
      component:() => import("@/views/apiDoc/children/logistics/subscribe.vue"),
    },{
      path:"/apiDoc/other/messageSend",
      name:"othermessageSend",
      meta:{pathSet:"/apiDoc",title:"短信发送"},
      component:() => import("@/views/apiDoc/children/other/messageSend.vue"),
    },{
      path:"/apiDoc/other/sMSstatusReturn",
      name:"sMSstatusReturn",
      meta:{pathSet:"/apiDoc",title:"短信状态回传"},
      component:() => import("@/views/apiDoc/children/other/SMSstatusReturn.vue"),
    },{
      path:"/apiDoc/other/smsGetMobile",
      name:"smsGetMobile",
      meta:{pathSet:"/apiDoc",title:"短信代发查询"},
      component:() => import("@/views/apiDoc/children/other/smsGetMobile.vue"),
    },{
      path:"/apiDoc/other/cover",
      name:"othercover",
      meta:{pathSet:"/apiDoc",title:"超区查询"},
      component:() => import("@/views/apiDoc/children/other/cover.vue"),
    },{
      path:"/apiDoc/other/declarationStatusQuery",
      name:"declarationStatusQuery",
      meta:{pathSet:"/apiDoc",title:"申报状态查询"},
      component:() => import("@/views/apiDoc/children/other/declarationStatusQuery.vue"),
    },{
      path:"/apiDoc/other/covernew",
      name:"othercovernew",
      meta:{pathSet:"/apiDoc",title:"超区查询（新）"},
      component:() => import("@/views/apiDoc/children/other/covernew.vue"),
    },{
      path:"/apiDoc/other/pca",
      name:"otherpca",
      meta:{pathSet:"/apiDoc",title:"收派范围查询"},
      component:() => import("@/views/apiDoc/children/other/pca.vue"),
    },{
      path:"/apiDoc/other/getInfo",
      name:"othergetInfo",
      meta:{pathSet:"/apiDoc",title:"网点信息及三段码查询"},
      component:() => import("@/views/apiDoc/children/other/getInfo.vue"),
    },{
      path:"/apiDoc/other/settlementReturn",
      name:"settlementReturn",
      meta:{pathSet:"/apiDoc",title:"结算账单回传"},
      component:() => import("@/views/apiDoc/children/other/settlementReturn.vue"),
    },{
      path:"/apiDoc/other/realNameSaveInfo",
      name:"realNameSaveInfo",
      meta:{pathSet:"/apiDoc",title:"实名制信息上传"},
      component:() => import("@/views/apiDoc/children/other/realNameSaveInfo.vue"),
    },
    {
      path:"/apiDoc/other/freight",
      name:"freight",
      meta:{pathSet:"/apiDoc",title:"运费计算"},
      component:() => import("@/views/apiDoc/children/other/freight.vue"),
    },
    {
      path:"/apiDoc/other/threeSegmentCode",
      name:"threeSegmentCode",
      meta:{pathSet:"/apiDoc",title:"三段码查询(新)"},
      component:() => import("@/views/apiDoc/children/other/threeSegmentCode.vue"),
    },
    {
      path:"/apiDoc/other/intercept",
      name:"intercept",
      meta:{pathSet:"/apiDoc",title:"拦截下发"},
      component:() => import("@/views/apiDoc/children/other/intercept.vue"),
    },
    {
      path:"/apiDoc/other/interceptFeedback",
      name:"interceptFeedback",
      meta:{pathSet:"/apiDoc",title:"拦截下发回传"},
      component:() => import("@/views/apiDoc/children/other/interceptFeedback.vue"),
    },
    {
      path:"/apiDoc/tempCarTender/tenderOfferPrice",
      name:"tenderOfferPrice",
      meta:{pathSet:"/apiDoc",title:"投标或弃标接口"},
      component:() => import("@/views/apiDoc/children/tempCarTender/tenderOfferPrice.vue"),
    },
    {
      path:"/apiDoc/tempCarTender/queryTenderSortNum",
      name:"queryTenderSortNum",
      meta:{pathSet:"/apiDoc",title:"查询标的报价排名接口"},
      component:() => import("@/views/apiDoc/children/tempCarTender/queryTenderSortNum.vue"),
    },
    {
      path:"/apiDoc/tempCarTender/tenderOfferReturn",
      name:"tenderOfferReturn",
      meta:{pathSet:"/apiDoc",title:"招标信息发布回传接口"},
      component:() => import("@/views/apiDoc/children/tempCarTender/tenderOfferReturn.vue"),
    },
    {
      path:"/apiDoc/tempCarTender/tenderOfferPriceReturn",
      name:"tenderOfferPriceReturn",
      meta:{pathSet:"/apiDoc",title:"定标/废标/定标取消回传接口"},
      component:() => import("@/views/apiDoc/children/tempCarTender/tenderOfferPriceReturn.vue"),
    },
    {
      path:"/apiDoc/tempCarTender/queryTenderQuoteNum",
      name:"queryTenderQuoteNum",
      meta:{pathSet:"/apiDoc",title:"查询剩余报价次数"},
      component:() => import("@/views/apiDoc/children/tempCarTender/queryTenderQuoteNum.vue"),
    },
    {
      path:"/apiDoc/orderserve/messageTransmission",
      name:"messageTransmission",
      meta:{pathSet:"/apiDoc",title:"一段单信息下发接口"},
      component:() => import("@/views/apiDoc/children/orderserve/messageTransmission.vue"),
    },
    {
      path:"/apiDoc/orderserve/shipmentWaybill",
      name:"shipmentWaybill",
      meta:{pathSet:"/apiDoc",title:"二段单映射关系回传"},
      component:() => import("@/views/apiDoc/children/orderserve/shipmentWaybill.vue"),
    },
    {
      path:"/apiDoc/orderserve/paymentStatus",
      name:"paymentStatus",
      meta:{pathSet:"/apiDoc",title:"订单支付状态更新"},
      component:() => import("@/views/apiDoc/children/orderserve/paymentStatus.vue"),
    },
  ]
  },
  //个人中心
  {
      path:"/personalCenter",
      name:"PersonalCenter",
      component: () => import("@/views/personalCenter/Index.vue")
  },
  // 快速对接
  {
    path: "/docking",
    name: "Docking",
    component: () => import("@/views/docking/index.vue")
  },
  //控制台
  {
    path:"/control",
    name:"Control",
    meta:{pathSet:"/control"},
    component: () => import("@/views/control/Index.vue"),
    children: [
      {
          path:"personalCenter",
          name:"personalCenter",
          component: () => import("@/views/control/components/personalCenter.vue")
      },
      {
          path:"authentication",
          name:"authentication",
          component: () => import("@/views/control/components/authentication.vue")
      },
      {
          path:"application",
          name:"application",
          component: () => import("@/views/control/components/application.vue")
      },
      {
          path:"smsTemplateManage",
          name:"smsTemplateManage",
          component: () => import("@/views/control/messageManagement/Index.vue")
          // component: () => import("@/views/control/SmsTemplateManage.vue")
      },
    ]
  },
  {
    path:"/helpCenter",
    name:"HelpCenter",
    meta:{pathSet:"/helpCenter"},
    component: () => import("@/views/helpCenter/Index.vue")
  },
  // 管我们
  {
    path:"/aboutUs",
    name:"AboutUs",
    meta:{pathSet:"/aboutUs"},
    component: () => import("@/views/aboutUs/NewIndex.vue")
  },
  // 解决方案
  {
    path:"/solution",
    name:"Solution",
    meta:{pathSet:"/solution"},
    component: () => import("@/views/solution/index.vue")
  }
]

const router = new VueRouter({
//   mode: 'history',
  routes
})

export default router
